<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="light-blue accent-2 font-weight-bold title">
              {{ paket.kode }} - {{ paket.nama }}
            </v-col>                 
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Tgl. Pembuatan Paket
            </v-col>              
            <v-col cols="9" >
              {{ getDateFormattedDatefns(paket.createdAt) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold"> Nama Paket </v-col>
            <v-col cols="9"> {{ paket.nama }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Satuan Kerja
            </v-col>              
            <v-col cols="9" >
              {{ getDivisi(paket.satuanKerja) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Jenis Pengadaan
            </v-col>              
            <v-col cols="9" >
              {{ getJenisPengadaan(paket.jenisPengadaan) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Sistem Pengadaan
            </v-col>              
            <v-col cols="9" >
              {{ getSistemPengadaan(paket.metodePemilihan, paket.kualifikasi, paket.metodeEvaluasi) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Tahun Anggaran
            </v-col>              
            <v-col cols="9" >
              {{ paket.tahunAnggaran }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Nilai HPS Paket
            </v-col>              
            <v-col cols="9" >
              {{ getNumberSep(paket.totalPagu) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Sumber Dana
            </v-col>              
            <v-col cols="9" >
              <v-row v-for="item in listSumberDana" :key="item.id" >
                <v-col>{{ getSumberDana(item.sumberDana) }}</v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Jenis Kontrak
            </v-col>              
            <v-col cols="9" >
              {{ getJenisKontrak(paket.jenisKontrak) }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Lokasi Pekerjaan
            </v-col>              
            <v-col cols="9" >
              <v-row v-for="item in listLokasiKerja" :key="item.id" >
                <v-col>{{ getLokasiKerja(item.lokasiProyekId) }} - {{ item.detail }} </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              KBLI
            </v-col>              
            <v-col cols="9" >
              <template v-if="listKBLIDisplay.length>0">
                <p v-for="(kbli, i) in listKBLIDisplay" :key="i">
                  {{ listKBLIDisplay[i] }}
                </p>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Keterangan Paket
            </v-col>              
            <v-col cols="9" >
              {{ paket.deskripsi }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              Jumlah Peserta
            </v-col>              
            <v-col cols="9" >
              {{ listPeserta.length }} peserta
            </v-col>
          </v-row>

          <!-- JADWAL -->
          <v-row class="grey lighten-2 font-weight-bold subtitle-1">
            <v-col cols="12"> Jadwal Lelang </v-col>
          </v-row> 
          <v-row>
            <v-col cols="12">
              <v-data-table
                :items="filteredJadwal"
                :headers="user ? jadwalHeaders : vendorHeaders"
                disable-pagination
                :items-per-page="-1"
                hide-default-footer
              >
                <template v-slot:item.mulai="{item}">                  
                  {{ getDateFormattedDatefns(item.mulai, "dd MMM yyyy HH:mm") }}                    
                </template>

                <template v-slot:item.selesai="{item}">                  
                    {{ getDateFormattedDatefns(item.selesai, "dd MMM yyyy HH:mm") }}                    
                </template>
                
                <!--
                <template v-slot:item.include="{ item }">
                  <v-simple-checkbox v-model="item.include" disabled></v-simple-checkbox>
                </template>
                -->

                <template v-slot:item.fileJadwal="{item}">
                  <v-tooltip v-if="showDownloadFileJadwal(item)" top>
                      <template v-slot:activator="{on, attrs}">
                          <v-btn v-bind="attrs" v-on="on" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, `FileJadwal_${item.urut}`, item.fileJadwal, false)"><v-icon>get_app</v-icon></v-btn>
                      </template>
                      <span>Download File: {{ item.fileJadwal }}</span>
                  </v-tooltip>
                </template>

                <template v-slot:item.dokumen="{ item }">
                  <v-btn @click="getDocx(item.printout)" >Dokumen</v-btn>
                </template>

                <template v-slot:item.remark="{item}">
                  <v-textarea v-model="item.remark" auto-grow readonly outlined />
                </template>

              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import { getValueItem, itemsDivisi, sumberDana, } from './../../lib/viewLib'
import { itemsMetodePemilihan, itemsJenisPengadaan, itemsKualifikasi, itemsMetodeEvaluasi, itemsJenisKontrak, listJadwalPengadaan } from './../../lib/viewTenderLib'
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { TenderLib } from "./../../lib/tenderLib";

export default {
  props: {
    user: {
      type: Boolean,
      default: false
    },
    vendorEvaluasi: {
      type: Object,
      default: null
    },
  },

  data() {
    return {
      tenderLib: TenderLib,
      listLokasiKerja: [],
      listSumberDana: [],
      listKBLIDisplay: [],
      listPeserta: [],

      itemsDivisi: itemsDivisi,
      allListSumberDana: sumberDana,
      allListKualifikasi: itemsKualifikasi,
      allListJenisPengadaan: itemsJenisPengadaan,
      allListMetodePemilihan: itemsMetodePemilihan,
      allMetodeEvaluasi: itemsMetodeEvaluasi,
      allJenisKontrak: itemsJenisKontrak,
      allJadwalPengadaan: listJadwalPengadaan,
      listLokasiProyek: [],
      listKBLI: [],

      jadwalHeaders: [
        // { text: "No.", value: "urut", class: "subtitle-2 font-weight-bold", sortable: false, width: "1%" }, 
        { text: "Tahap", value: "tahap", class: "subtitle-2 font-weight-bold", sortable: false, width: "10%" },
        { text: "Arsip", value: "noArsip", class: "subtitle-2 font-weight-bold", sortable: false, width: "10%" },
        { text: "Mulai", value: "mulai", class: "subtitle-2 font-weight-bold", sortable: false, width: "10%" },
        { text: "Selesai", value: "selesai", class: "subtitle-2 font-weight-bold", sortable: false, width: "10%" },
        { text: "File", value: "fileJadwal", class: "subtitle-2 font-weight-bold", sortable: false, width: "2%" },
        { text: "Dokumen", value: "dokumen", class: "subtitle-2 font-weight-bold", sortable: false, width: "2%" },
        { text: "Remark", value: "remark", class: "subtitle-2 font-weight-bold", sortable: false },
        //{ text: "", value: "include", class: "subtitle-2 font-weight-bold", sortable: false, width: "1%" },
      ],

      vendorHeaders: [
        //{ text: "No.", value: "urut", class: "subtitle-2 font-weight-bold", sortable: false, width: "1%" }, 
        { text: "Tahap", value: "tahap", class: "subtitle-2 font-weight-bold", sortable: false, width: "20%" },
        { text: "Tgl Mulai", value: "mulai", class: "subtitle-2 font-weight-bold", sortable: false, width: "12%" },
        { text: "Tgl Selesai", value: "selesai", class: "subtitle-2 font-weight-bold", sortable: false, width: "12%" },
        { text: "File", value: "fileJadwal", class: "subtitle-2 font-weight-bold", sortable: false, width: "2%" },
        { text: "Remark", value: "remark", class: "subtitle-2 font-weight-bold", sortable: false },
        //{ text: "", value: "include", class: "subtitle-2 font-weight-bold", sortable: false, width: "1%" },
      ],

    }
  },
  computed: {
    paket: function() {
      return this.$store.getters['lelang/paket']
    },
    jadwal: function() {
      return this.$store.getters['lelang/jadwal']
    },
    filteredJadwal: function() {
      console.log('this.jadwal.filter(el => el.include)',this.jadwal.filter(el => el.include))
      return this.jadwal.filter(el => el.include);
    },
    isPeserta: function() {
      return this.$store.getters['lelang/peserta']
    },
  },
  /* props: {
    paket: Object,
    jadwal: Array,
  }, */
  watch: {
    paket: function(newVal, oldVal) {
      console.log(`oldVal = ${oldVal}, newVal = ${newVal}`)
      this.getPaketDataList(newVal)
      this.getKBLI(this.paket.kbli)
    }
  },
  created: async function() {
    await this.getListLokasiProyek()
    await this.getListKBLI()
    await this.getPaketDataList(this.paket)    
    await this.getKBLI(this.paket.kbli)
  },
  mounted: async function() {
    
  },
  methods: {
    showDownloadFileJadwal(jadwal) {
      if (jadwal.fileJadwal === "") return false;
      if (this.user) return true;

      if (jadwal.showVendor && this.vendorEvaluasi) {
        console.log("Akses file jadwal VENDOR");

        // PENUNJUKAN LANGSUNG
        if (this.paket.metodePemilihan === "TLA") {
          if (jadwal.urut >= 1 && jadwal.urut <= 11) return true;
          return (this.vendorEvaluasi.urutan == 1);
        }
        // PENGADAAN LANGSUNG
        else if (this.paket.metodePemilihan === "PLA") {
          if (jadwal.urut >= 1 && jadwal.urut <= 5) return true;
          return (this.vendorEvaluasi.urutan == 1);
        }
        // TENDER
        else if (this.paket.metodePemilihan === "TEN") {
          // Prakualifikasi
          if (this.paket.kualifikasi === 'P') {
            if (jadwal.urut >= 1 && jadwal.urut <= 11) return true;
            if (jadwal.urut >= 12 && jadwal.urut <= 25) return this.vendorEvaluasi.lulusKualifikasi;
            return (this.vendorEvaluasi.urutan == 1);
          }
          // Pascakualifikasi 1 file
          else if (this.paket.kualifikasi === 'K') {
            if (jadwal.urut >= 1 && jadwal.urut <= 13) return true;
            return (this.vendorEvaluasi.urutan == 1);
          }
          // Pascakualifikasi 2 file
          else {
            if (jadwal.urut >= 1 && jadwal.urut <= 18) return true;
            return (this.vendorEvaluasi.urutan == 1);
          }

        }
        // SELEKSI
        else if (this.paket.metodePemilihan === "SEL") {
          // Prakualifikasi
          if (this.paket.kualifikasi === 'P') {
            if (jadwal.urut >= 1 && jadwal.urut <= 9) return true;
            if (jadwal.urut >= 10 && jadwal.urut <= 21) return (this.vendorEvaluasi.hasilAdministrasi && this.vendorEvaluasi.lulusTeknis);
            return (this.vendorEvaluasi.urutan == 1);
          }
          // Pascakualifikasi
          else if (this.paket.kualifikasi === 'K') {
            if (jadwal.urut >= 1 && jadwal.urut <= 12) return true;
            return (this.vendorEvaluasi.urutan == 1);
          }
        }
      }

      return false;
    },
    getLinkDownload: function(dok) {
        axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
        .then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = dok
            link.click()
            URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    getDocx(printout) {
      const url = apiUrl + printout + this.paket.id;
      axios.get(url)
        .then((response) => {
            if(response.status === 200) {
                this.getLinkDownload(response.data.file);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    getDateFormattedDatefns: function(date, form = "dd MMM yyyy") {
      // console.log(`tgl yg masuk: ${date}`)
      return date ? format(parseISO(date), form) : ''
    },
    getNumberSep: function(data) {
      return parseInt(data, 10).toLocaleString('de-DE')
    },
    getDivisi: function(data) {
      return data ? getValueItem(itemsDivisi, data) : ''
    },
    getJenisPengadaan(val) {
      return val ? getValueItem(this.allListJenisPengadaan, val) : ''
    },
    getMetodeEvaluasi(evaluasi) {
      const itemEval = this.allMetodeEvaluasi.find(el => el.value.includes(this.paket.jenisPengadaan))
      return itemEval ? getValueItem(itemEval.items, evaluasi) : ''
    },
    getSistemPengadaan(metode, kualifikasi, evaluasi) {
      const met = metode ? getValueItem(this.allListMetodePemilihan, metode) + ' - ' : ''
      const kua = kualifikasi ? getValueItem(this.allListKualifikasi, kualifikasi) + ' - ' : ''
      const eva = evaluasi ? this.getMetodeEvaluasi(evaluasi) : ''
      return `${met}${kua}${eva}`
    },
    getJenisKontrak(val) {
      const itemEval = this.allJenisKontrak.find(el => el.value.includes(this.paket.jenisPengadaan))
      return itemEval ? getValueItem(itemEval.items, val) : ''
    },
    getKBLI(val) {
      console.log('Ambil KBLI')
      this.listKBLIDisplay = []
      let kbli = undefined
      if (val.includes(',')) {
        kbli = val.split(',')
      }
      else {
        kbli = [val]
      }
      let item = null
      kbli.forEach(el => {
        console.log(el)
        item = this.listKBLI.find(el2 => el2.id == Number(el))
        console.log(item)
        if (item) {
          this.listKBLIDisplay.push(`${item.kategori} - ${item.kode} - ${item.nama}`)
        }
      })
      
      this.$store.dispatch('lelang/assignKBLIDisplay', this.listKBLIDisplay)
    },
    getListKBLI() {      
      return new Promise((resolve, reject) => {
        this.listKBLI = []
        axios.get(`${apiUrl}/api/rup/kbli`)
        .then( (response) => {
          this.listKBLI = response.data
          resolve(this.listKBLI)
        })
        .catch( (error) => {
          reject(error);
        });
      })
    },
    getListLokasiProyek() {
      this.listLokasiProyek = []
      // get program items
      axios.get(`${apiUrl}/api/rup/lokasiproyek`)
      .then( (response) => {
        this.listLokasiProyek = response.data
      })
      .catch( (error) => {
          console.error(error);
      });
    },
    getLokasiKerja(id) {
      const lokasi = this.listLokasiProyek.find(el => el.id === id);
      if (lokasi == null) return "LOKASI TIDAK DITEMUKAN!";
      return lokasi.nama;
    },
    getSumberDana(val) {
      return getValueItem(this.allListSumberDana, val)
    },
    getPaketDataList(paket) {
      axios.get(apiUrl+`/api/rup/paket/lokasi-kerja/${paket.id}`)
      .then( (response) => {
          console.log("List lokasi kerja: ", response.data);
          this.listLokasiKerja = response.data;
      });
      axios.get(apiUrl+`/api/rup/paket/sumber-dana/${paket.id}`)
      .then( (response) => {
          // console.log("List sumber dana: ", response.data);
          this.listSumberDana = response.data;
      });
      axios.get(apiUrl+`/api/rup/paket/peserta/${paket.id}`)
      .then( (response) => {
          // console.log("List sumber dana: ", response.data);
          this.listPeserta = response.data;
      });
    },
  }
}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
.v-textarea {
    font-size: 1.0em;
}
</style>
